import React from 'react'

export interface ScoreLineProps {
  /** Pontos do jogador/equipe A */
  scoreA: number | null
  /** Pontos do jogador/equipe B */
  scoreB: number | null
  /** Identifica o vencedor do set */
  winner?: 'A' | 'B'
}

const ScoreLine: React.FC<ScoreLineProps> = ({ scoreA, scoreB, winner }) => {
  const colorA = winner === 'A' ? '#0dcaf0' : '#dc3545'
  const colorB = winner === 'B' ? '#0dcaf0' : '#dc3545'
  return (
    <div className="d-flex justify-content-center">
      <span className="me-1" style={{ color: colorA }}>
        {scoreA}
      </span>
      <span>:</span>
      <span className="ms-1" style={{ color: colorB }}>
        {scoreB}
      </span>
    </div>
  )
}

export default ScoreLine
